/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * MinimizeIcon
 */
export default class MinimizeIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M10.4 13.1c-.1-.1-.3-.1-.4-.1H4c-.6 0-1 .4-1 1s.4 1 1 1h3.6l-5.3 5.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3L9 16.4V20c0 .6.4 1 1 1s1-.4 1-1v-6c0-.1 0-.3-.1-.4-.1-.2-.3-.4-.5-.5zM21.7 2.3c-.4-.4-1-.4-1.4 0L15 7.6V4c0-.6-.4-1-1-1s-1 .4-1 1v6c0 .1 0 .3.1.4.1.2.3.4.5.5.1.1.3.1.4.1h6c.6 0 1-.4 1-1s-.4-1-1-1h-3.6l5.3-5.3c.4-.4.4-1 0-1.4z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

